import {
  useMarkAllNotificationsAsRead,
  useMarkNotificationAsRead,
} from '../api/mutations/use-notification-mutations';
import {
  useNotificationHistory,
  useNotificationsStatus,
  useUserNotifications,
} from '../api/queries/use-notification-queries';

export const useNotifications = () => {
  const {
    data: current = [],
    isPending: isLoadingCurrent,
    error: errorCurrent,
    refetch: refetchCurrent,
  } = useUserNotifications();

  const {
    data: history = [],
    isPending: isLoadingHistory,
    error: errorHistory,
    refetch: refetchHistory,
  } = useNotificationHistory();

  const {
    data: status,
    isPending: isLoadingStatus,
    error: errorStatus,
    refetch: refetchStatus,
  } = useNotificationsStatus();

  const markAsReadMutation = useMarkNotificationAsRead();
  const markAllAsReadMutation = useMarkAllNotificationsAsRead();

  const handleReadAll = () => markAllAsReadMutation.mutateAsync();
  const handleReadById = (notificationId: string) =>
    markAsReadMutation.mutateAsync(notificationId);

  const isLoading = isLoadingCurrent || isLoadingHistory || isLoadingStatus;
  const error = errorCurrent || errorHistory || errorStatus;
  const unreadCount = status?.unread ?? 0;

  return {
    current,
    history,
    refetchCurrent,
    refetchHistory,
    refetchStatus,
    unreadCount,
    handleReadAll,
    handleReadById,
    isLoading,
    error,
  };
};
